import { call, put, takeLatest, delay, select } from "redux-saga/effects";
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

const getSelected = state => state.UserOrgSiteReducer.selected;

function* createTrainingSaga({ payload }) {
    try {
        const roleModified = Object.keys(payload.selected_roles || {}) || [];
        const selected = yield select(getSelected);
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.CREATE_TRAINING,
            data: {
                organization: selected.org,
                site: payload.selected_site.id,
                department: payload.selected_dep.id,
                due: payload.due,
                regulatory_act: payload.regulatory_act,
                reminder: payload.reminder,
                training_course: payload.selected_course.document_id,
                user: payload.userId,
                role: roleModified.map(Number),
                launch_date: payload.launch_date,
                configuration: {
                    frequency: payload.frequency,
                    lock_tasks: payload.lock_tasks
                }
            }
        });
        if (apiResponse) {
            yield put({ type: ActionTypeConstants.CREATE_TRAINING_SUCCESS });
            yield put({ type: ActionTypeConstants.LOAD_TRAININGS });
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.data.message || "Successfully created training",
                    color: "success"
                }
            });
            yield delay(10000);
            yield put({ type: ActionTypeConstants.HIDE_ALERT });    
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.data.message || "Error creating training",
                    color: "danger"
                }
            });
            yield delay(10000);
            yield put({ type: ActionTypeConstants.HIDE_ALERT });
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "Error creating training",
                color: "danger"
            }
        });
        yield delay(10000);
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(ActionTypeConstants.CREATE_TRAINING, createTrainingSaga);
}
